import angular from 'angular';
import '../../services/errors';
import '../../services/organization';
import '../../services/segments';
import { get } from 'lodash';
import { SubscriptionTypes } from '../../utils/subscriptionTypes';

const module = angular.module('whyline.modals.line-flow-type-view', [
  'whyline.services.line-flow-type-organization',
  'whyline.services.errors',
  'whyline.services.organization',
  'whyline.services.segment',
]);

const LineFlowTypeViewModalController = (
  $scope,
  $uibModalInstance,
  $timeout,
  LineFlowTypeOrganizationService,
  ErrorService,
  lineFlowTypeOrganizationId,
  OrganizationService,
  SegmentService,
) => {
  'ngInject';

  $scope.segments = [];
  $scope.organization = [];
  $scope.subscriptionTypes = SubscriptionTypes;
  $scope.organization = OrganizationService.GetCurrent();

  if ($scope.organization.configuration.queuer.useSegments) {
    SegmentService.GetAllAsPromiseFromServer()
      .then((segmentsDB) =>
        Object.values(segmentsDB).map((segmentDB) => $scope.segments.push(segmentDB)),
      )
      .catch(ErrorService.handler);
  }

  LineFlowTypeOrganizationService.GetOneAsPromiseFromServer(lineFlowTypeOrganizationId)
    .then((lineFlowTypeOrganization) => {
      $scope.lineFlowTypeOrganization =
        LineFlowTypeOrganizationService.Copy(lineFlowTypeOrganization);
    })
    .catch(ErrorService.handler);

  $scope.getOrganizationSegmentName = (organizationSegmentId) => {
    if ($scope.segments.length) {
      const organizationSegment = $scope.segments.find(
        (segment) => segment.organizationSegmentId.toString() === organizationSegmentId,
      );
      return get(organizationSegment, 'name', '') || '';
    }
  };

  $scope.close = () => {
    $uibModalInstance.close(false);
  };
};

module.exports = module.controller(
  'LineFlowTypeViewModalController',
  LineFlowTypeViewModalController,
);
